<template>
  <v-dialog
    v-model="value"
    fullscreen
    class="bar"
    persistent
    scrollable
  >
    <v-card class="card-add-image">
      <v-card-title class="d-flex justify-center pt-1" style="background-color: white; z-index: 3;">
        <v-tabs v-model="manageImageType" class="d-flex justify-center" @change="onChageManageImageType">
          <v-tab><v-icon left>mdi-crop</v-icon> {{ $t('crop') }}</v-tab>
          <v-tab><v-icon left>mdi-image-size-select-large</v-icon> {{ $t('size') }}</v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-title class="d-flex justify-center pt-1" v-if="manageImageType == 0" style="box-shadow: 0px 2px 2px rgb(198, 198, 198); z-index: 2; background-color: white;">
        <v-btn 
          text 
          @click="cropImage()"
          :disabled="isLoading"
        ><v-icon left color="success">mdi-check</v-icon> {{ $t('validate.confirm_to_edit') }}</v-btn>
        <v-btn 
          text 
          @click="cnacelCropImage()"
          :disabled="isLoading"
        ><v-icon left color="error">mdi-close</v-icon> {{ $t('validate.cancel_to_edit') }}</v-btn>
      </v-card-title>
      <v-card-title class="d-flex justify-center py-0" v-if="manageImageType == 1" style="background-color: white; z-index: 3; background-color: white;">
        <div style="width: 400px; scale: .8">
          <v-slider
            v-model="imageWidth"
            :max="sliderMaxWidth"
            :min="1"
            label="Width"
            class="align-center"
            color="blue"
            hide-details
            @input="onChageSize('width')"
            :disabled="isLoading"
          >
            <template v-slot:append>
              <v-currency-field
                v-model="imageWidth"
                outlined
                dense
                class="mt-0 pt-0"
                style="width: 100px"
                suffix="px"
                hide-details
              />
            </template>
          </v-slider>
          <div class="link-variant">
            <v-icon @click="onLockAspect" :color="isLockAspect ? 'success' : ''">mdi-link-variant</v-icon>
          </div>
        </div>
      </v-card-title>
      <v-card-title class="d-flex justify-center py-0" v-if="manageImageType == 1" style="box-shadow: 0px 2px 2px rgb(198, 198, 198); z-index: 2; background-color: white;">
        <div style="width: 400px; scale: .8">
          <v-slider
            v-model="imageHeight"
            :max="sliderMaxHeight"
            :min="1"
            label="Height"
            class="align-center"
            color="blue"
            hide-details
            @input="onChageSize('height')"
            :disabled="isLoading"
          >
            <template v-slot:append>
              <v-currency-field
                v-model="imageHeight"
                outlined
                dense
                class="mt-0 pt-0"
                style="width: 100px"
                suffix="px"
                hide-details
              />
            </template>
          </v-slider>
        </div>
      </v-card-title>
      <v-card-text class="px-4 py-15">
        <div class="d-flex justify-center">
          <div v-show="manageImageType == 0">
            <VueCropper
              ref="cropper"
              :src="imgSrc"
              :zoomable="false"
              :viewMode="1"
              :autoCropArea="1"
            />
          </div>
          <img
            v-show="manageImageType == 1" 
            :src="imgSrc" alt="" id="image-crop"
            :style="`width: ${imageWidth ? imageWidth+'px' : 'auto'}; height: ${imageHeight ? imageHeight+'px' : 'auto'};`"
          >
        </div>
      </v-card-text>
      <v-card-actions style="box-shadow: 0px -2px 2px rgb(198, 198, 198); z-index: 2; background-color: white;">
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          type="submit"
          elevation="0"
          @click="uploadImage()"
          :disabled="isLoading"
        >
          <v-icon left>mdi-upload</v-icon> {{ $t('insert_image') }}
        </v-btn>
        <v-btn
          color="error"
          elevation="0"
          @click="dismiss()"
          :disabled="isLoading"
        >{{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { FileUpload } from "../classes"
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import Pica from 'pica';

export default {
  props: {
    value: Boolean,
    fileData: File
  },
  components: {
    VueCropper
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      imgSrc: null,
      isManageImageDialog: false,
      manageImageType: 0,
      imageWidth: 0,
      imageHeight: 0,
      tempImageWidth: 0,
      tempImageHeight: 0,
      sliderMaxWidth: 0,
      sliderMaxHeight: 0,
      isLockAspect: false,
    }
  },
  watch: {
    value(){
      if(this.value){
        this.resetForm()
        this.initData()
      }
    }
  },
  methods: {
    dismiss(){
      this.$emit("dismiss" , false)
      this.$emit("input" , false)
    },
    resetForm(){
      this.manageImageType = 0
      this.imageWidth = 0
      this.imageHeight = 0
      this.imageWidth = 0
      this.tempImageWidth = 0
      this.tempImageHeight = 0
      this.sliderMaxWidth = 0
      this.sliderMaxHeight = 0
      this.isLockAspect = false
    },
    initData(e) {
      const file = this.fileData
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        this.isManageImageDialog = true
        const _this = this
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);

          var image = new Image();

          //Set the Base64 string return from FileReader as source.
          image.src = event.target.result;
          //Validate the File Height and Width.
          image.onload = function () {
            _this.imageWidth = this.width
            _this.imageHeight = this.height
          };
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    onChageManageImageType(){
      if(this.manageImageType == 1){
        const image = document.getElementById('image-crop');
        setTimeout(() => {
          this.imageWidth = image.width
          this.imageHeight = image.height

          this.tempImageWidth = image.width
          this.tempImageHeight = image.height

          this.sliderMaxWidth = image.width * 2
          this.sliderMaxHeight = image.height * 2
          if(!this.isLockAspect) this.onLockAspect()
        }, 50)
      }else{
        const image = document.getElementById('image-crop');
        setTimeout(() => {
          this.resizeImage(image, this.imageWidth , this.imageHeight)
        }, 50)
      }
    },
    cropImage(){
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.imgSrc = this.cropImg
      this.$refs.cropper.replace(this.cropImg);
      
      let data = this.$refs.cropper.getData()
      this.imageWidth = data.width
      this.imageHeight = data.height

      this.tempImageWidth = data.width
      this.tempImageHeight = data.height

      this.sliderMaxWidth = data.width * 2
      this.sliderMaxHeight = data.height * 2
    },
    cnacelCropImage(){
      this.$refs.cropper.clear()
    },
    async resizeImage(imgEl, width, height) {
      const picaInstance = new Pica();
      const canvas = document.createElement('canvas');
      const outputCanvas = document.createElement('canvas');

      // Set canvas dimensions
      canvas.width = imgEl.naturalWidth;
      canvas.height = imgEl.naturalHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(imgEl, 0, 0);

      outputCanvas.width = width;
      outputCanvas.height = height;

      try {
        await picaInstance.resize(canvas, outputCanvas, {
          quality: 3,  // High-quality resizing
          alpha: false,
        });

        const resizedImageDataURL = outputCanvas.toDataURL('image/png', 1.0);
        this.imgSrc = resizedImageDataURL;

        this.$refs.cropper.replace(resizedImageDataURL);

        return resizedImageDataURL;
      } catch (error) {
        console.error('Error resizing image:', error);
        return null;
      }
    },
    onLockAspect(){
      this.isLockAspect = !this.isLockAspect
      if(this.isLockAspect){
        this.tempImageHeight = JSON.parse(JSON.stringify(this.imageHeight))
        this.tempImageWidth = JSON.parse(JSON.stringify(this.imageWidth))
      }
    },
    onChageSize(type){
      let ar = this.tempImageWidth / this.tempImageHeight
      if(this.isLockAspect){
        if(type == "width"){
          this.imageHeight = Math.round(this.tempImageHeight + (this.imageWidth - this.tempImageWidth) / ar)
        }else{
          this.imageWidth = Math.round(this.tempImageWidth + (this.imageHeight - this.tempImageHeight) * ar)
        }
      }
    },
    async uploadImage(){
      this.isLoading = true
      try{
        let imageData;
        if(this.manageImageType == 0){
          imageData = this.$refs.cropper.getCroppedCanvas().toDataURL()
        }else{
          const image = document.getElementById('image-crop');
          imageData = await this.resizeImage(image, this.imageWidth , this.imageHeight)
        }
        let fileData = await FileUpload.urlToFile(imageData, "image.jpg", "image/jpeg")
        let file = await FileUpload.upload(fileData)

        this.$emit("onSuccess" , file)
        this.isLoading = false
        this.dismiss()
      }catch(error){
        this.isError = true
        this.isLoading = false
        this.dismiss()
      }
    }
  }
}
</script>
<style scoped>
.card-add-image{
  background-color: rgba(255, 255, 255, 0.6);
}
.link-variant{
  position: absolute;
  display: inline;
  top: 33px;
  right: -55px;
}
</style>